module.exports = __webpack_public_path__ + "static/media/skywallet_1.f0e3d9ff.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/skywallet_1.jpeg
// module id = 1502
// module chunks = 0